import {
  FormFieldProps,
  MultiChoiceFormFieldProps,
} from 'components/inspection/Form/types';
import React, { useMemo } from 'react';
import { InspectionTranslationKeys, ProjectSetupTranslationKeys } from 'intl/keys';
import { ContractFormPresentational } from './presentational';
import { ContractFormProps } from './types';
import { EditableStandardEntityName } from 'shared/domain/fieldValue/fields';
import { ContractOnView } from 'shared/domain/contract/types/view';

function ContractForm({
  companies,
  isDialog,
}: ContractFormProps): React.ReactElement {
  const labelFieldProps: FormFieldProps<ContractOnView> = useMemo(
    () => ({
      formKey: 'label',
      required: true,
      labelId: InspectionTranslationKeys.contractNumber,
      fieldName: 'text-field-contract-number',
      localStorageKey: 'contract-number',
      reserveSpaceForHelperText: !isDialog,
      dense: true,
      'data-qa': 'contract_number_field',
      issueParams: null,
    }),
    [isDialog]
  );

  const partiesFieldProps: MultiChoiceFormFieldProps<ContractOnView> =
    useMemo(
      () => ({
        formKey: 'parties',
        required: true,
        labelId: ProjectSetupTranslationKeys.parties,
        fieldName: 'multiselect-parties',
        available: companies,
        reserveSpaceForHelperText: !isDialog,
        dense: true,
        entityName: EditableStandardEntityName.company,
        'data-qa': 'contract_parties_field',
        issueParams: null,
      }),
      [isDialog, companies]
    );

  return (
    <ContractFormPresentational
      labelFieldProps={labelFieldProps}
      partiesFieldProps={partiesFieldProps}
    />
  );
}

export const MemoContractForm = React.memo(ContractForm);
